import { menuClasses, filledInputClasses } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { blueGrey } from "../../../../mp-core/themes/palette"

export const useStyles = makeStyles()(({ spacing, palette }) => ({
  button: {
    lineHeight: "1.17rem",
    height: "fit-content"
  },
  anchorIcon: {
    color: blueGrey[400]
  },
  dropdownWrapper: {
    display: "flex"
  },
  chipsContainer: {
    position: "relative",
    flexDirection: "row",
    flexWrap: "wrap",
    gap: spacing(1),
    margin: "-2px 0"
  },
  checkboxContainer: {
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
    margin: spacing(2, 0)
  },
  menu: {
    [`& .${menuClasses.paper}`]: {
      maxWidth: "440px"
    },

    [`& .${menuClasses.list}`]: {
      padding: spacing(3)
    }
  },
  dataInput: {
    width: "100%",
    [`& > .${filledInputClasses.root}`]: {
      backgroundColor: palette.common.white,
      border: "1px solid #B0BEC5",
      borderRadius: "3px",
      "&:hover": {
        borderColor: blueGrey[400]
      }
    }
  }
}))
